module.exports = __webpack_public_path__ + "static/media/2DGACM6.a0535747.jpg";